import {
  ListItem,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import { Button } from '@web-app/components/ui/Button/button';
import React, { useEffect, useRef } from 'react';

const SignosReminderModal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialFocusRef = useRef<HTMLElement>(null);

  useEffect(() => {
    onOpen();
  }, [onOpen]);

  return (
    <SessionReminderModal
      popupId="signos-patient-reminders"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      initialFocusRef={initialFocusRef}
    >
      <ModalOverlay />
      <ModalContent
        ref={initialFocusRef as React.Ref<HTMLElement>}
        tabIndex={-1}
        sx={{ outline: 'none' }}
        bg="bg.default"
        color="text.default"
      >
        <ModalHeader>Signos Patient Reminders</ModalHeader>

        <ModalBody>
          <UnorderedList spacing={3} pl={2}>
            <ListItem>
              <strong>What is Signos?</strong> A metabolic health platform that
              combines continuous glucose monitoring (CGM) with AI-powered data
              to provide real-time nutritional insights.
            </ListItem>
            <ListItem>
              Berry Street is working on a more robust integration to read CGM
              data from Signos directly.
            </ListItem>
            <ListItem>
              Partnerships are vital to the Berry Street ecosystem — revisit
              Signos FAQs{' '}
              <a
                href="https://www.signos.com/faqs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-legacy underline"
              >
                here
              </a>{' '}
              or our CGM recording{' '}
              <a
                href="https://community.berrystreet.co/c/professional-discussion-groups/sections/873375/lessons/3737089"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-legacy underline"
              >
                here
              </a>
              .
            </ListItem>
          </UnorderedList>
        </ModalBody>

        <ModalFooter>
          <div className="flex w-full flex-col gap-2">
            <Button
              onClick={onClose}
              className="w-full bg-primary-legacy text-primary-foreground hover:bg-primary-legacy/90"
            >
              Got it!
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};

export default SignosReminderModal;
